<template>
  <slide-view v-model:toggle="info.menu.toggle">
    <a-menu :items="info.menu.items" :inline-collapsed="info.menu.toggle" v-model:open-keys="info.menu.openKeys"
            v-model:selected-keys="info.menu.selectedKeys" mode="inline" @click="onMenuClick"/>
  </slide-view>
</template>

<script setup lang="ts">

import SlideView from "@/views/share/SlideView.vue";
import {h, reactive} from "vue";
import {MenuProps} from "ant-design-vue";
import {InfoCircleOutlined, UserOutlined} from "@ant-design/icons-vue";
import {useRoute} from "vue-router";
import router from "@/views";

const route = useRoute();
const info = reactive({
  menu: {
    toggle: false,
    items: [
      {key: 'service', icon: h(UserOutlined), label: 'VIP会员'},
      {key: 'theme', icon: h(UserOutlined), label: '订制主题'},
      {key: 'element', icon: h(UserOutlined), label: '订制元素'},
      {key: 'production', icon: h(UserOutlined), label: '代制作'},
      {key: 'teach', icon: h(UserOutlined), label: '在线操盘'},
      {key: 'ad', icon: h(UserOutlined), label: '自定义广告'},
    ] as MenuProps['items'],
    openKeys: [] as string[],
    selectedKeys: [route.path.split('/').last()] as string[],
  }
});

const onMenuClick = (e: any) => {
  if (e.key === 'service') router.push(`/service`);
  else router.push(`/service/${e.key}`);
}
</script>

<style scoped lang="sass">
.ant-menu
  padding-top: 18px
</style>